import { styled } from "styled-components";

export const LogoWrapper = styled.img`
  max-width: 220px;
  max-height: 75px;
  object-fit: contain;
`;
